import { SelectBoxOption } from 'sos-common/js/components/FormControls/SelectBox';
import { FileExtendedDetails } from 'sos-common/js/commonTypes/fileupload.types';
import { IeServiceFormPayload } from './Eserviceform.model';
import { DHSCategory } from './specialistbevisansokan.model';

export interface AnsokanFormTexts {
  PersonuppgifterBody: string;
  PersonuppgifterHeading: string;
  PersonuppgifterCouldNotBeLoadedBody: string;
  PersonuppgifterCouldNotBeLoadedHeading: string;
  SamtyckeExplanation: string;
  SamtyckeLabel: string;
  AnsokanFormTexts: string;
  DocumentInfo: string;
}
export interface FolkbokforingsAdress {
  Namn: string;
  PersonNummer: string;
  CareOf: string;
  Utdelningsadress1: string;
  Utdelningsadress2: string;
  PostNr: string;
  Postort: string;
}

export interface LegAnsokan {
  Id: number;
  Epost: string;
  Telefonnummer?: string;
  Utbildning: Utbildning;
  PrimaryFiles: FileExtendedDetails[];
  SecondaryFiles: FileExtendedDetails[];
  AccepteratVillkor: boolean;
  CheckboxValue?: boolean;
  Fileupload1Files: FileExtendedDetails[];
  Fileupload2Files: FileExtendedDetails[];
  Fileupload3Files: FileExtendedDetails[];
  Fileupload4Files: FileExtendedDetails[];
  Fileupload5Files: FileExtendedDetails[];
  Fileupload6Files: FileExtendedDetails[];
  Fileupload7Files: FileExtendedDetails[];
}

export interface Utbildning {
  UtbildningslandId?: string;
  LarosateId?: string;
  YrkeId?: string;
  ExamensDatum?: string;
  LegitimationAnnatlandId?: string;
  LegitimationAndraLander?: string[];
  Utbildningslangd?: string;
  legitimationFranAnnatLand?: boolean;
  Examensar?: string;
  Utbildningstitel?: string;
  DatumForLegitimeradOmYrkesbehorighet?: string;
  DiarienummerTidigareAnsokan?: string;
  EftergymnasialUtbildning?: boolean;
  GranskningExamen?: string;
  LarosateNamn?: string;
  UtbildningPaborjad?: string;
  UtbildningslandNamn?: string;
  ArbetatEfterExamen?: boolean;
  TillatelseKontaktaSkolaMyndighet?: boolean;
  MotiveringEjKontaktaSkolaMyndighet?: string;
  BetaltVidGranskning?: boolean;
  DatumForTidigareBetalning?: string;
  GjortKompletterandeUtbildning?: boolean;
}

export interface AnsokanFormStepOneModel {
  OccupationId: string;
  ImportantInformation: string;
  AvailableSchools: SelectBoxOption[];
  UtbildningsLander: SelectBoxOption[];
  PreviewAndPaymentPageLink: string;
  YrkesNamn: string;
  ExtraInformation: string;
  PrimaryFileUploadText: FileUploadText;
  SecondaryFileUploadText: FileUploadText;
  FileUploadText1: FileUploadText;
  FileUploadText2: FileUploadText;
  FileUploadText3: FileUploadText;
  FileUploadText4: FileUploadText;
  FileUploadText5: FileUploadText;
  FileUploadText6: FileUploadText;
  FileUploadText7: FileUploadText;
}

export enum EducationLocation {
  EducatedInSweden = 0,
  EducatedInEuEes = 1,
  EducatedOutsideEuEes3year = 2,
  EducatedOutsideEuEes = 3,
  EducatedOutsideEuEesAssessment = 4,
}

export interface FileUploadText {
  IntroText: string;
  Label: string;
  Required: boolean;
  Show: boolean;
  DHSCategory: DHSCategory;
}

export interface LegAnsokanPayload extends IeServiceFormPayload {
  LarosateId?: string;
  LarosateNamn?: string;
  ExamensDatum?: string;
  Examensar?: string;
  Telefonnummer?: string;
  AccepteratVillkor?: boolean;
  CheckboxValue?: boolean;
  UtbildningslandId?: string;
  UtbildningslandNamn?: string; // Med stor bokstav här också
  Utbildningstitel?: string;
  Utbildningslangd?: string;
  UtbildningPaborjad?: string;
  DatumForLegitimeradOmYrkesbehorighet?: string;
  LegitimationAndraLander?: string[];
  LegitimationFranAnnatLand?: boolean;
  Diarienummer?: string;
  DiarienummerTidigareAnsokan?: string;
  EftergymnasialUtbildning?: boolean;
  ArbetatEfterExamen?: boolean;
  TillatelseKontaktaSkolaMyndighet?: boolean;
  MotiveringEjKontaktaSkolaMyndighet?: string;
  BetaltVidGranskning?: boolean;
  DatumForTidigareBetalning?: string;
  GjortKompletterandeUtbildning?: boolean;
}

export interface SpecAnsokanPayload {
  AnsokanId: number;
}
